import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { UserAccess } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipComponent from 'webapp/components/tool-tip';

import type Goal from 'webapp/models-custom/goal';

interface Args {
	model: Goal;
	isDisabled?: boolean;
	saveOnChange?: boolean;
	tooltipText?: string;
}

export default class GoalsVisibilityInlineComponent extends Component<Args> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('account') declare accountService: Service.Account;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	@tracked isPopupOpen = false;

	el!: JQuery;

	get model() {
		return this.args.model;
	}

	get visibilityText() {
		switch (this.model.access) {
			case UserAccess.PUBLIC:
				return 'All users';
			case UserAccess.RESTRICTED:
				return `Me and ${this.model.users.length - 1} users`;
			default:
				return 'Private';
		}
	}

	get visibilityIcon(): IconName | undefined {
		switch (this.model.access) {
			case UserAccess.PRIVATE:
				return 'Lock';
			case UserAccess.RESTRICTED:
				return 'Team';
			case UserAccess.PUBLIC:
				return 'Globe';
		}
	}

	@action
	changeVisibility() {
		if (this.args.isDisabled) {
			return;
		}

		if (this.accountService.handleDemo()) {
			return;
		}

		this.analyticsService.event(TrackingEvent.GOAL_PERMISSIONS_POPUP, {
			goal_id: this.model.id,
		});

		this.mmGoalsService.openGoalAccessTypePopup(this.model, this.args.saveOnChange, true);
	}
	<template>
		<div class="inline-visibility">
			{{#if this.visibilityIcon}}
				<CommonUiIconComponent @name={{this.visibilityIcon}} @size="lg" />
			{{/if}}
			<span>{{this.visibilityText}}</span>
			<a
				role="button"
				class="link link--blue {{if @isDisabled 'disabled'}}"
				{{on "click" this.changeVisibility}}
			>Change
			</a>
			{{#if @tooltipText}}
				<ToolTipComponent @text={{@tooltipText}} @position="top" />
			{{/if}}
		</div>
	</template>
}
